import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import Divider from 'dashboard/components/Divider';
import { ModalBody, ModalContainer, ModalFooter, ModalHeader } from 'dashboard/layouts/ModalLayout';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { Span } from 'design-system/components/Text';

const StyledModalFooter = styled(ModalFooter)`
  display: flex;
  grid-column-start: 4;
  justify-content: flex-end;
  padding-right: ${Spacing[4]};

  > * + * {
    margin-left: ${Spacing[3]};
  }
`;

interface ExpandDataModalProps {
  expandData: () => void;
  onClose: () => void;
}

export const ExpandDataModal = ({ expandData, onClose }: ExpandDataModalProps) => {
  return (
    <ModalContainer>
      <ModalHeader onClose={onClose}>Access Sensitive Data</ModalHeader>
      <Divider full={true} />
      <ModalBody css={{ justifyContent: 'space-between' }}>
        <Span>
          Enables access to sensitive information, including PII, for the duration of your query
          session.
        </Span>
        <Spacer height={2} />
        <Span>Note: It can take up to a few minutes for the sensitive data tables to appear.</Span>
      </ModalBody>
      <Divider full={true} />
      <StyledModalFooter>
        <Button variant='basic' width='auto' onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant='primary'
          width='auto'
          onClick={async () => {
            await expandData();
            onClose();
          }}
        >
          Continue
        </Button>
      </StyledModalFooter>
    </ModalContainer>
  );
};
